import React, { useState, useEffect } from 'react';
import { useHistory, useParams, useLocation } from "react-router-dom";
import { Helmet } from 'react-helmet';
import { Row, Col, Container } from 'react-bootstrap';
import Banner from '../../components/banner.js';
import Sidebar from '../../components/sidebar.js';
import { getProductList, getSearchHints } from '../../Services/ProductSearchService'
import parse from 'html-react-parser';
import '../../styles/searchresults.scss'
import { logPageViews } from '../../Services/LoginService.js';
import { IconSearch,IconSquareRoundedArrowRightFilled, IconUserSquareRounded, IconInfoCircleFilled,IconListSearch, IconCaretDownFilled, IconInfoTriangleFilled,IconArrowBadgeUpFilled, IconZoomCheckFilled, IconFilterFilled, IconX, IconTrash, IconExternalLink, IconRestore, IconArrowRight } from '@tabler/icons-react'; // Import Icon
import { useMediaQuery, Select, InputLabel, Skeleton, CircularProgress, Accordion, AccordionSummary, ButtonGroup, AccordionDetails, TextField, Checkbox,Collapse, Divider, InputAdornment, ListItemButton, ListSubheader, Alert, AlertTitle, Chip, Typography, IconButton, FormControl, FormLabel, Button, Tooltip, FormControlLabel,FormGroup, Autocomplete, Tab, Tabs, Box,Table, TableBody, TableFooter, TableCell, TableContainer, TableHead, TableRow, Paper, TablePagination, Pagination, Badge, Fab, Zoom, List, ListItem, ListItemIcon, ListItemText, Stack, Dialog, DialogActions, DialogContent, DialogTitle  } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { Link } from 'react-router-dom';
import { useThemeManager } from '../../Context/ThemeManager.js';

const SearchResults = () => {
    const {theme} = useThemeManager();
    const [activeButton, setActiveButton] = useState('search');
    const { name: searchName } = useParams();
    const molecule = safeDecodeURIComponent(searchName);
    // Sanitize URL decoding
    function safeDecodeURIComponent(str) {
        try {
            return decodeURIComponent(str);
        } catch (e) {
            // replace lone '%' not followed by two hex digits with '%25'
            const fixedStr = str.replace(/%(?![0-9A-Fa-f]{2})/g, '%25');
            try {
                return decodeURIComponent(fixedStr);
            } catch (e2) {
                // still broken? return original or empty string
                return str;
            }
        }
    }
    const [results, setResults] = useState([])
    const [hints, setHints] = useState([])
    const history = useHistory();

    const search = useLocation().search;
    const params = new URLSearchParams(search);

    const showHints = params.get("hints") ?? ''
    function showLoader() {
        const el = document.getElementById("loader");
        if (el) {
          el.style.setProperty("display", "flex", "important");
          el.style.zIndex = "1000";
        }
    }

    function hideLoader() {
        const el = document.getElementById("loader");
        if (el) {
        el.style.display = "none";
        }
    }
    const country = localStorage.getItem("Activecountryversion");
    useEffect(() => {
        document.title = "Search Results";
        console.log("Molecule: ", molecule)
        if (country === "New Zealand") {
            document.documentElement.style.setProperty('--primary-color', theme.primary);
            document.documentElement.style.setProperty('--secondary-color', '#D99A00');
            document.documentElement.style.setProperty('--titleGradient', '#E69A00, #eba313, #eeab24');
        } else {
            document.documentElement.style.setProperty('--primary-color', theme.primary);
            document.documentElement.style.setProperty('--secondary-color', '#002195');
            document.documentElement.style.setProperty('--titleGradient', '#0262AB, #0e86e2, #0197e2');
        }
        const fetchAllData = async () => {
            showLoader();
            setResults([]);
            if (showHints === '') setHints([]);

            try {
            // Fetch search results if molecule is valid
            if (molecule.length > 1) {
                const data = await getProductList(molecule, true);
                setResults(
                data?.map((items) => ({
                    id: items.id,
                    type: items.type,
                    label: items.productName,
                    acg: items.acg,
                }))
                );
                
            }

            // Fetch hints if showHints is not empty
            if (showHints !== '') {
                const hintData = await getSearchHints(showHints);
                setHints(
                hintData?.map((items) => ({
                    id: items.id,
                    label: parse(items.productName),
                }))
                );
            }

            // Log page view
            await logPageViews("Search", molecule, showHints);
            } catch (error) {
            console.error("Error in SearchResults useEffect:", error);
            } finally {
            hideLoader();
            }
        };

        fetchAllData();
    }, [molecule, showHints]);

    console.log ("Results: ", results)
    const isLgScreen = useMediaQuery('(min-width:1024px)');

    return (
        <>
        <Helmet>
            <meta name="viewport" content="width=device-width, initial-scale=1" />
        </Helmet>  
        <Banner />
        <Sidebar activeButton={activeButton} />
        <div id="searchResults">
            <Container fluid id="main">
                <div id="content">
                    <div id="contentCaption">
                        <h2>Search Results</h2>
                        {hints?.length > 0 &&
                        <div id="hints" className='mt-3' style={{textAlign: !isLgScreen ? "left" : ""}}>
                            <span style={{fontSize: !isLgScreen ? 12 :""}}>You searched: <b style={{wordBreak: 'break-all', color: "#202020", fontSize: isLgScreen ? 20: 14}}>"{showHints}"</b></span>
                            <div id="suggestions" style={{fontSize: !isLgScreen ? 12 :""}}>
                                <span style={{color: "#d32f2f", whiteSpace: 'nowrap'}}>Did you mean:</span>
                                <div id="suggestionItems"> 
                                   {hints.map((items, index) => {
                                    const safeLabel = items.label ? items.label.replace(/%/g, '%25') : '';
                                        return (
                                            <Link key={index} to={`/SearchResults/${encodeURIComponent(safeLabel)}`}>
                                            {items.label}
                                            </Link>
                                        );
                                    })}
                                </div>
                            </div>
                        </div>
                        }
                        {!isLgScreen && <hr />}
                    </div>
                    <Row id="resultsContainer" className={ isLgScreen ? 'my-3 d-flex flex-row' : 'mt-1 mb-3 d-flex flex-row'}>
                        <Col lg={12} className='d-flex flex-column p-0'>
                        {isLgScreen ? (<> 
                            <span className="align-self-start m-0">
                                {hints?.length > 0 ? 'Showing results containing: ' : 'Results for: '}
                                <b style={{color:theme.primary}}>{molecule}</b>
                            </span>
                            <span style= {{marginTop: "12px", color: "#727272"}}>
                                Total: <b style={{color: "#202020"}}>{results.length}</b>
                            </span>
                        </>):(<>
                            
                            <span className='mb-3' style={{fontSize: 12, paddingLeft: 12, paddingRight: 12}}>
                                Showing <b>{results.length}</b> {results.length === 1 ? 'result' : 'results'} for <b style={{ color: theme.primary }}>{molecule}</b>
                            </span>

                        </>)}
                            
                        </Col>
                        {isLgScreen ? (<>
                            {results.length > 0 &&
                        <TableContainer component={Paper} sx={{ mt: 2 }} >
                            <Table aria-label="simple table" >
                                <TableHead>
                                <TableRow >
                                    <TableCell sx={{fontWeight: "bold", color: "#ffffff"}} style={{paddingTop: "16px", paddingBottom: "16px"}}>Product</TableCell>
                                    <TableCell sx={{fontWeight: "bold", color: "#ffffff"}} style={{paddingTop: "16px", paddingBottom: "16px"}}>Active Ingredient</TableCell>
                                    <TableCell sx={{px:0}}></TableCell> {/* Empty header for button */}
                                </TableRow>
                                </TableHead>
                                <TableBody>
                                { results.map((e, index) => (
                                    <TableRow
                                    key={index} 
                                    onClick={()=> history.push('/ProductDetails/' + e.id)}
                                    sx={{
                                        cursor: "pointer",
                                        "&:hover": { backgroundColor: "#f5f5f5" },
                                        py: "40px"
                                    }}
                                    >
                                    <TableCell className='molecule'>{parse(e.label)}</TableCell>
                                    <TableCell className={parse(e.acg).split(" + ").length > 4 ? "multipleActiveIngredient" : "activeIngredient"}>{e.acg.split(" + ").length > 4 ? 'Multiple Ingredients' : e.acg}</TableCell>
                                    <TableCell align="center">
                                        <Button variant="text" size="small" sx={{ minWidth: 0, p: 0 }}>
                                        <IconSquareRoundedArrowRightFilled color={theme.primary} size={20} />
                                        </Button>
                                    </TableCell>
                                    </TableRow>
                                ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                          }
                        </>) : (<>
                        <Box width={"100%"} >
                        <Row className='mb-1 py-2'style={{ fontSize: 10, fontWeight: "bold", alignItems: "center", backgroundColor: theme.primary, color: "#ffffff"  }}>
                            <Col xs={7} md={7}>
                                <span>Product</span>
                            </Col>
                            <Col xs={4} md={4} style={{textAlign: "center", paddingLeft: 0}}>
                            <span> Active Ingredient </span>
                            </Col>
                            <Col xs={1} md={1}>
                            </Col>
                        </Row>
                        { results.map((e, index) => (
                                <Row
                                    className='mobileRows'
                                    style={{ fontSize: 12 }}
                                    key={index} 
                                    onClick={()=> history.push('/ProductDetails/' + e.id)}
                                >
                                    <Col xs={7} md={7}>
                                    <span style={{color: theme.primary, fontWeight: "bold"}}>
                                    {parse(e.label)}
                                       
                                    </span>
                                    </Col>


                                    <Col xs={4} md={4}>
                                    <span style={{color: e.acg.split(" + ").length > 4 ? "#727272" : theme.primary, fontStyle: e.acg.split(" + ").length > 4 ? "italic" : "normal"}}>
                                    {e.acg.split(" + ").length > 4 ? 'Multiple Ingredients' : e.acg}
                                    </span>
                                    </Col>
                                    <Col xs={1} md={1} style={{display: "flex", alignItems:"center", justifyContent: "center", margin: "8px 0", padding:0}}>
                                        <IconArrowRight color={theme.primary} size={16} />
                                    
                                    </Col>
                                    <hr className='m-0 mt-2'/> 
                                </Row>
                                
                        ))}
                        </Box>
                        </>)}
                        

                    </Row>

                </div>
            </Container>
        </div>
        </>
    )
}

export default SearchResults;
